import { render, staticRenderFns } from "./GeodirMapDelivery.vue?vue&type=template&id=080f9084"
import script from "./GeodirMapDelivery.vue?vue&type=script&lang=js"
export * from "./GeodirMapDelivery.vue?vue&type=script&lang=js"
import style0 from "./GeodirMapDelivery.vue?vue&type=style&index=0&id=080f9084&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports